import { Injectable } from '@angular/core';
import { BaseService } from 'src/app/shared/services/base.service';
import { environment } from 'src/environments/environment';
@Injectable()
export class AporteService extends BaseService {
  getThisMonthIntakeValue() {
    const url = `${environment.portalApi}/Intake/GetThisMonthIntakeValue`;
    return this.http.get(url, { headers: this.createHeader() });
  }
  postIntake(request: any) {
    const url = `${environment.portalApi}/Intake/SaveIntakeSolicitation`;
    return this.http.post(url, request, { headers: this.createHeader() });
  }
  getOriginValue() {
    let url = environment.portalApi + '/OriginValue/GetAllOriginValue';
    return this.http.get(url, { headers: this.createHeader() });
  }
}
